const fieldNames = {
  URL_VALUE: 'urlValue',
  IS_FULLSCREEN_ALLOWED: 'isFullscreenAllowed',
  EMBED_CODE: 'embedCode',
};

export default fieldNames;
